// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"94db73c4","113":"d6c0bca1","261":"cf169075","502":"f7ba6dc5","724":"09da7546","725":"09da7546","737":"94db73c4"}[chunkId] + ".chunk.css";
};